<template>
  <div class="grid grid-cols-1 lg:grid-cols-2 gap-4">
    <StoreRetributionsRanking
      v-if="ranking?.length > 0"
      :sellersWithRetributionRanking="ranking"
      :showRetributionDetails="true"
      @viewRetributions="viewRetributions"
    />
    <SellersRanking
      title="Classement réseau"
      emoji="🌐"
      badge-class="bg-blue-50"
      v-if="organizationRanking.length > 0"
      :sellersRanking="organizationRanking"
      :currentSellerIds="currentSellerIds"
    />
  </div>
</template>

<script>
import StoreRetributionsRanking from "@/components/store/StoreRetributionsRanking.vue";
import SellersRanking from "@/components/seller/SellersRanking.vue";

export default {
  name: "RetributionsRanking",
  components: { StoreRetributionsRanking, SellersRanking },

  props: {
    ranking: {
      type: Array,
      default: () => [],
    },
    organizationRanking: {
      type: Array,
      default: () => [],
    },
  },

  computed: {
    currentSellerIds() {
      return this.ranking.map((sellerRetribution) => sellerRetribution.seller.id);
    },
  },

  methods: {
    viewRetributions(sellerId) {
      this.$emit("viewDetails", sellerId);
    },
  },
};
</script>
